import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToSignComponent } from './to-sign.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { CtFileUploaderModule, CtSearchFiltersModule } from '@ctsolution/ct-framework';
import { CartOrderModule } from 'src/app/_components/cart-order/cart-order.module';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { ToSignUploadComponent } from './to-sign-upload/to-sign-upload.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlowFileUploaderModule } from 'src/app/_components/flow-components/file-uploader/flow-file-uploader.module';

@NgModule({
  imports: [FlowFileUploaderModule,CommonModule, CartOrderModule, CtSearchFiltersModule, MatButtonModule, MatCardModule, MatIconModule, MatDialogModule, CtFileUploaderModule, FormsModule, ReactiveFormsModule ],
  declarations: [ToSignComponent, ToSignUploadComponent],
  exports: [ToSignComponent]
})
export class ToSignModule { }
